import { AdminPartnersPage } from '../../features/superadmin/partners/AdminPartnersPage';

const SuperadminPartnersPage: React.FC = () => <AdminPartnersPage />;

export default SuperadminPartnersPage;
